<template>
    <v-card>
        <v-card-text class="text-center pa-7" v-if="!loaded">
            <v-progress-circular
                indeterminate
                color="indigo"
                class="ma-5"
            ></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
            <chart
                ref="chart"
                height="200"
                :options="options"
                :series="series"
            ></chart>
        </v-card-text>
    </v-card>
</template>

<script>
import ApexChartHelper from './ApexChartHelper'
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['resellerTypeRefer'],

    components: {
        chart: VueApexCharts,
    },

    data: () => {
        return {
            loaded: false,
            series: [],
        }
    },

    watch: {
        resellerTypeRefer() {
            this.loaded = false
            this.fetchData().then(() => (this.loaded = true))
        },
    },

    computed: {
        helper() {
            return new ApexChartHelper()
        },

        options() {
            return {
                chart: {
                    type: 'line',
                },
                title: this.helper.title({
                    text: 'Aquisição de Parceiros e Clientes',
                }),
                colors: ['#118eed', '#09ed8e'],
                xaxis: {
                    categories: this.labels,
                    type: 'datetime',
                },
                tooltip: {
                    x: {
                        format: 'MM/yyyy',
                    },
                    y: {
                        formatter: value => {
                            return parseInt(value)
                        },
                    },
                },
            }
        },
    },

    methods: {
        async fetchData() {
            const which = 'which[]=customers.count&which[]=resellers.count'
            let endpoint = '/dashboard/kpis/monthly?' + which

            if (this.resellerTypeRefer) {
                endpoint +=
                    '&aggregators[reseller_type_refer]=' +
                    this.resellerTypeRefer
            }

            let res = await this.$http.get(endpoint)
            this.dataHandler(res.data)
        },

        dataHandler(data) {
            let customers = []
            let resellers = []

            this.labels = Object.keys(data)

            this.labels.forEach(element => {
                let customersCount = data[element]['customers.count']
                    ? data[element]['customers.count']
                    : 0
                let resellersCount = data[element]['resellers.count']
                    ? data[element]['resellers.count']
                    : 0

                customers.push(customersCount)
                resellers.push(resellersCount)
            })

            this.series = [
                {
                    name: 'Clientes',
                    data: customers,
                },
                {
                    name: 'Parceiros',
                    data: resellers,
                },
            ]
        },
    },

    created() {
        this.fetchData().then(() => (this.loaded = true))
    },
}
</script>

<style></style>
